'use strict';

var first = require('../array/first');

/**
 * Ritorna la posizione attuale del cursore all'interno di un input field
 * @param $el
 * @returns {Integer}
 */
module.exports = function getCursorPosition($el) {
    var input = first($el),
        selection,
        pos;

    if (!input) {
        return -1;
    }

    // default caret position
    pos = 0;
    // ie way of doing things
    if (document.selection) {
        input.focus();
        selection = document.selection.createRange();
        selection.moveStart('character', -input.value.length);
        pos = selection.text.length;
    } else if (input.selectionStart || input.selectionStart === '0') {
        pos = input.selectionStart;
    }
    return pos;
};
